module.exports = __webpack_public_path__ + "static/tools.b39842b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/debugger/img/p1/tools.png
// module id = 560
// module chunks = 136876265974512